// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d59266c7","845":"c3cc4d18"}[chunkId] + ".chunk.js";
};